import React from 'react'

export default function Footer() {
    return (
        
<footer className="app-footer">
 <p>&copy; FarahMint 2020</p>
</footer>
    )
}
